import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';
import { Subscription, timer } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import {
    CallStatus,
    CallStatusNotification,
    CallStatusService,
    HubMethods,
} from '../core';

import { TranslationKeyMap } from './call-dialog.i18n';
import { CallDialogData } from './model/call-dialog-data.model';

@Component({
    selector: 'cmps-teamscall-call-dialog',
    templateUrl: './call-dialog.component.html',
    host: {
        class: 'cmps-teamscall-call-dialog',
    },
})
@TakeUntilDestroy()
export class CallDialogComponent
    implements OnInit, OnDestroy, TakeUntilDestroy
{
    /** @private */ _i18n = TranslationKeyMap;

    /** @private */ _statusStr: string;
    /** @private */ _hasTimeout: boolean;
    /** @private */ _hasError: boolean;

    private _messageSub: Subscription;
    private _timeoutSub: Subscription;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CallDialogComponent,
            void
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _dialogData: CallDialogData,
        private readonly _service: CallStatusService,
    ) {
        this._reset();
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    /** @private */
    _onHasValidTokenChange(hasValidToken: boolean): void {
        if (!hasValidToken) {
            console.log('no valid msft token');
            return;
        }
        void this._service.createMeeting(this._dialogData.meetingRequest);
    }

    /** @private */
    _onRetryClick(): void {
        this._reset();
        void this._service.createMeeting(this._dialogData.meetingRequest);
    }

    private _reset(): void {
        this._statusStr = null;
        this._hasTimeout = null;
        this._hasError = null;
        this._messageSub?.unsubscribe();
        this._timeoutSub?.unsubscribe();

        this._bind();
        // this._scheduleTimeout();
    }

    private _bind(): void {
        this._statusStr = TranslationKeyMap._9994_TAKE_30_SECONDS;

        this._messageSub = this._service.message
            .pipe(
                filter(
                    (noti) =>
                        noti.hubMethod === HubMethods.OnCallStatus &&
                        this._service.callHandle?.callHandleId != null &&
                        (noti.payload as CallStatusNotification)
                            ?.callHandleId ===
                            this._service.callHandle?.callHandleId,
                ),
                map((noti) => noti.payload as CallStatusNotification),
                tap((noti) => {
                    switch (noti.status) {
                        case CallStatus.CREATED:
                            this._statusStr =
                                TranslationKeyMap._11030_CALL_CREATED___;
                            break;
                        case CallStatus.ESTABLISHING:
                            this._statusStr =
                                TranslationKeyMap._11046_ESTABLISHING_CALL___;
                            break;
                        case CallStatus.INVITING:
                            this._statusStr =
                                TranslationKeyMap._11047_CALL_ESTABLISHED____INVITING_;
                            break;
                        case CallStatus.INVITED:
                            this._didSucceed();
                            break;
                        case CallStatus.ERROR:
                            // this._didFail();
                            break;
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    private _scheduleTimeout(): void {
        this._timeoutSub = timer(60000)
            .pipe(
                tap(() => {
                    this._hasTimeout = true;
                    this._messageSub?.unsubscribe();
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    private _didSucceed(): void {
        this._hasTimeout = false;
        this._statusStr = TranslationKeyMap._11031_THE_CALL_HAS_BEEN_CONNECTED_;
        this._messageSub?.unsubscribe();
        this._timeoutSub?.unsubscribe();
        this._scheduleClose();
    }

    private _didFail(): void {
        this._hasTimeout = false;
        this._hasError = true;
        this._statusStr = TranslationKeyMap._11048_THE_CALL_HAS_FAILED_;
        this._messageSub?.unsubscribe();
        this._timeoutSub?.unsubscribe();
    }

    private _scheduleClose(): void {
        timer(5000)
            .pipe(
                tap(() => {
                    this._dialogRef.close();
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
